import { apiService } from './apiService'

export const notificationsService = {
  // Fetch all alerts for the user
  async getAlerts() {
    try {
      return await apiService.get('/api/alerts')
    } catch (error) {
      console.error('Error fetching alerts:', error)
      throw error
    }
  },

  // Create new alert
  async createAlert(alertData) {
    try {
      return await apiService.post('/api/alerts', alertData)
    } catch (error) {
      console.error('Error creating alert:', error)
      throw error
    }
  },

  // Update existing alert
  async updateAlert(alertId, alertData) {
    try {
      return await apiService.put(`/api/alerts/${alertId}`, alertData)
    } catch (error) {
      console.error('Error updating alert:', error)
      throw error
    }
  },

  // Delete alert
  async deleteAlert(alertId) {
    try {
      return await apiService.delete(`/api/alerts/${alertId}`)
    } catch (error) {
      console.error('Error deleting alert:', error)
      throw error
    }
  },

  // Toggle alert active status
  async toggleAlert(alertId, active) {
    try {
      return await apiService.post(`/api/alerts/${alertId}/toggle`, { active })
    } catch (error) {
      console.error('Error toggling alert:', error)
      throw error
    }
  },
}
